import { render } from "./achievementDemandDetail.vue?vue&type=template&id=5353af66&scoped=true"
import script from "./achievementDemandDetail.vue?vue&type=script&lang=js"
export * from "./achievementDemandDetail.vue?vue&type=script&lang=js"

import "./achievementDemandDetail.vue?vue&type=style&index=0&id=5353af66&lang=less&scoped=true"

import exportComponent from "G:\\阳泉\\portal-display-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5353af66"]])

export default __exports__